import classes from './sceButton.scss';
import Enum from 'enum';

var buttonTypeEnum = new Enum({
  'default': 'sceBtnDefault', 'primary': 'sceBtnPrimary', 'secondary': 'sceBtnSecondary', 'light': 'sceBtnLight', 'dark': 'sceBtnDark', 'transparent': '', 'sceClose': 'sceBtnClose',
  'sceSmPrimary': 'sceBtnSmPrimary', 'sceSmlight': 'sceBtnSmLight', 'sceSmDefault': 'sceBtnSmDefault', 'sceFullPrimary': 'sceBtnFullSizePrimary', 'sceFullDark': 'sceBtnFullSizeDark', 'sceSmCancel': 'sceSmBtnCancel',
  'sceCancel': 'sceBtnCancel', 'sceFullGrey': 'sceBtnFullSizeMediumGrey', 'sceSmSecondary': 'sceBtnSmSecondary', 'sceDisabled': 'sceBtnDisabled', 'sceGo': 'sceBtnGo', 'sceButtonBg': 'sceButtonBg', 'sceBtnSmGrey':'sceBtnSmGrey',
  'sceBtnDisabledPrimary':'sceDisabledPrimary','sceTabDark':'sceBtnTabDark','sceTabLight':'sceBtnTabLight','sceFullDisabled':'sceBtnFullDisabled','sceCloseBtn':'sceCloseBtn','sceBtnFullGrey':'sceBtnFullGrey','sceBtnFullGreyMC':'sceBtnFullGreyMC','sceBtnFullDarkGold':'sceBtnFullDarkGold',
});
var iconTypeEnum = new Enum({ 'leftArrow': 'fas fa-chevron-left', 'rightArrow': 'fas fa-chevron-right', 'cancel': 'fas fa-times', 'upArrow': 'fas fa-chevron-up', 'downArrow': 'fas fa-chevron-down', 'return':'fas fa-redo', 'externalLink':'fas fa-external-link-alt' });
var colorEnum = new Enum({ 'default': '', 'iconNeutralBlack': classes.sceNeutralBlack });
let additionalJSX;
const SceButton = function (props) {
  const buttonTypeClass = classes[buttonTypeEnum.get(props.buttonType) + ''];
  const iconClass = iconTypeEnum.get(props.iconType) ? iconTypeEnum.get(props.iconType).value : '';
  const btnIconColor = colorEnum.get(props.iconColor) ? colorEnum.get(props.iconColor).value : '';
  const iconJSX = props.iconType ? <i disabled="disabled" className={[iconClass, btnIconColor].join(' ')} /> : null;
  const buttonVal = props.iconPosition && props.iconPosition === 'right' ? <span>{props.value} {iconJSX}</span> :
    <span>{iconJSX} {props.value}</span>;
  return (
    <button type='button' disabled={props.isDisabled} className={[buttonTypeClass].join(' ')} id={props.id} onClick={props.onClick} onMouseDown={props.onMouseDown}>{buttonVal}</button>
  );
};

export default SceButton;

SceButton.defaultProps = {
  iconType: '',
  buttonType: 'sceBtnPrimary',
  isDisabled: false,
  iconPosition: 'right',
  iconColor: 'default',
  id: '',
  name: ''
};
